import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useRef
} from 'react';
interface ModuleData {
  id: string;
  name: string;
  expanded: boolean;
  description?: string;
  duration?: string;
  type: string;
  sequence: number;
  module_lock_type_id?: any;
  locked_until_date?: string;
  Module_Completed?: boolean;
  IsUnlocked?: boolean;
  is_completed?: boolean;
  typeId: number;
  locked_linked_items?: {
    id: string;
    item_name: string;
    entity_completion_type_id: any;
    entity_completion_sub_type_id: any;
    module_link_id: any;
    module_id: any;
    type: 'file' | 'link' | 'content' | 'assignment' | 'onlinetest' | 'module';
  }[];
  files?: {
    id: string;
    name: string;
    ParentName: string;
    blob_file_extension?: string;
    fileexpanded: boolean;
    time?: string;
    score?: string;
    typeId: number;
    lock_type_id: number;
    locked_until_date?: string;
    type: string;
    module_id: any;
    sequence: number;
    ChildItems_Completed?: boolean;
    IsUnlocked?: boolean;
    is_completed?: boolean;
    additionalFiles?: {id: string; name: string}[];
    locked_linked_items?: {
      id: string;
      item_name: string;
      entity_completion_type_id: any;
      entity_completion_sub_type_id: any;
      module_link_id: any;
      module_id: any;
      type:
        | 'file'
        | 'link'
        | 'content'
        | 'assignment'
        | 'onlinetest'
        | 'module';
    }[];
  }[];
}
interface fetchData {
  fileId: string;
  moduleId: string;
  fetched: boolean;
}
interface DropDownData {
  Name: string;
  Values: {label: string; value: number}[];
}
// Define the shape of the context data
interface MyContextType {
  ModulePreviewData: ModuleData[];
  SetModulePreviewData: (value: any) => void;
  questionsData: any;
  setQuestionData: (value: any) => void;
  uiFieldsMain: any;
  setUiFieldsMain: (value: any) => void;
  currentSlide: any;
  setCurrentSlide: (value: any) => void;
  isFullscreen: boolean;
  setIsFullscreen: (value: boolean) => void;
  isPlaying: boolean;
  setIsPlaying: (value: boolean) => void;
  selectedPreviewFile: any;
  setSelectedPreviewFile: (value: any) => void;
  dropDownData: DropDownData[];
  setDropDownData: (value: any) => void;
  fetchData:fetchData|undefined;
  setFetchData: (value: any|undefined) => void;
}

// Create the context with default values
const ModulePreviewContext = createContext<MyContextType | undefined>(
  undefined
);

// Create a provider component
export const ModulePreviewContextProvider: React.FC<{
  children: ReactNode;
  moduledata: ModuleData[];
}> = ({children, moduledata}) => {
  const [ModulePreviewData, SetModulePreviewData] =
    useState<ModuleData[]>(moduledata || []);
  const [questionsData, setQuestionData] = useState<any[]>([]);
  const [uiFieldsMain, setUiFieldsMain] = useState();
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [fetchData, setFetchData] = useState<any>();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [dropDownData, setDropDownData] = useState<DropDownData[]>([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [selectedPreviewFile, _setSelectedPreviewFile] = useState<any | null>(
    null
  );

  // ✅ Use correct type for useRef
  const prevSelectedFile = useRef<any | null>(selectedPreviewFile);

  // ✅ Only update state if the selected file is different
  const setSelectedPreviewFile = (newFile: any | null) => {
    if (JSON.stringify(prevSelectedFile.current) !== JSON.stringify(newFile)) {
      prevSelectedFile.current = newFile;
      _setSelectedPreviewFile(newFile);
    }
  };

  return (
    <ModulePreviewContext.Provider
      value={{
        ModulePreviewData,
        SetModulePreviewData,
        questionsData,
        setQuestionData,
        uiFieldsMain,
        setUiFieldsMain,
        currentSlide,
        setCurrentSlide,
        isFullscreen,
        setIsFullscreen,
        isPlaying,
        setIsPlaying,
        fetchData,
        setFetchData,
        selectedPreviewFile,
        setSelectedPreviewFile,
        dropDownData,
        setDropDownData
      }}>
      {children}
    </ModulePreviewContext.Provider>
  );
};

// Custom hook to use the context
export const useModulePreviewContext = () => {
  const context = useContext(ModulePreviewContext);
  if (context === undefined) {
    throw new Error(
      'useOnlineContext must be used within an OnlineContextProvider'
    );
  }
  return context;
};
